import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-affiliate-frozen-commission-card',
  templateUrl: './user-affiliate-frozen-commission-card.component.html',
  styleUrls: ['./user-affiliate-frozen-commission-card.component.scss'],
})
export class UserAffiliateFrozenCommissionCardComponent {
  @Input() data: any;
}
